var _defs, _rect, _rect2, _rect3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumericalLinearAlgebra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c084fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#60a5fa"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 480,
    rx: 24,
    fill: "url(#grad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 80,
    width: 248,
    height: 12,
    rx: 6,
    fill: "rgba(255,255,255,0.65)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 118,
    width: 182,
    height: 12,
    rx: 6,
    fill: "rgba(255,255,255,0.6)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(15,23,42,0.65)",
    fontFamily: "'Montserrat', 'Segoe UI', sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 210,
    fontSize: 40,
    fontWeight: 600
  }, "Numerical"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 260,
    fontSize: 40,
    fontWeight: 600
  }, "Linear"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 310,
    fontSize: 40,
    fontWeight: 600
  }, "Algebra"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(15,23,42,0.55)",
    fontFamily: "'Fira Code', monospace",
    fontSize: 22
  }, /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 380
  }, "A = QR"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 410
  }, "\u03BB\u2081 \u2265 \u03BB\u2082"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumericalLinearAlgebra);
export default __webpack_public_path__ + "static/media/numerical-linear-algebra.e26cf4df9491b4c55c70e3d7040ff86f.svg";
export { ForwardRef as ReactComponent };